import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './components/auth/signin/signin.component';
import { UserPermission } from './enums/enums';
import { LevelofserviceListComponent } from './components/configurations/levelofservice/levelofservice-list/levelofservice-list.component';
import { AddLevelofserviceComponent } from './components/configurations/levelofservice/add-levelofservice/add-levelofservice.component';
import { SpaceTypesListComponent } from './components/configurations/spacetype/space-types-list/space-types-list.component';
import { AddSpaceTypesComponent } from './components/configurations/spacetype/add-space-types/add-space-types.component';
import { AuthGuard } from './services/app/auth-guard/auth.guard';
import { PublicGuard } from './services/app/public-guard/public.guard';
import { SignupListComponent } from './components/signups/signup-list/signup-list.component';
import { CredentialListComponent } from './components/credentials/credentials-company/credential-list/credential-list.component';
import { CompanyListComponent } from './components/companies/company-list/company-list.component';
import { AddCompanyComponent } from './components/companies/add-company/add-company.component';
import { AddSignupComponent } from './components/signups/add-signup/add-signup.component';
import { CompanyComponent } from './components/credentials/company/company.component';
import { DriverComponent } from './components/credentials/drivers/driver/driver.component';
import { WrapperComponent } from './components/credentials/wrapper/wrapper.component';
import { DocumentsListComponent } from './components/configurations/documents/documents-list/documents-list.component';
import { AddDocumentComponent } from './components/configurations/documents/add-document/add-document.component';
import { AddDriverComponent } from './components/credentials/drivers/add-driver/add-driver.component';
import { AddVehicleComponent } from './components/credentials/vehicle/add-vehicle/add-vehicle.component';
import { AddFareComponent } from './components/credentials/fare/add-fare/add-fare.component';
import { AddCredentialCompanyComponent } from './components/credentials/credentials-company/add-credential-company/add-credential-company.component';
import { ThresholdComponent } from './components/credentials/threshold/threshold.component';
import { ThresholdListComponent } from './components/credentials/threshold-list/threshold-list.component';
import { UsersListComponent } from './components/user/users-list/users-list.component';
import { AddUserComponent } from './components/user/add-user/add-user.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ListRoleComponent } from './components/role/list-role/list-role.component';
import { AddRoleComponent } from './components/role/add-role/add-role.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { QuickbookNotificationsComponent } from './components/quickbook/notifications/quickbook-notifications/quickbook-notifications.component';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { CreateTripComponent } from './components/distributions/trip-intake/create-trip/create-trip.component';
import { MemberListComponent } from './components/distributions/members/member-list/member-list.component';
import { AddMemberComponent } from './components/distributions/members/add-member/add-member.component';
import { TripListComponent } from './components/distributions/trips/trip-list/trip-list.component';
import { StandingOrderListComponent } from './components/distributions/trip-intake/standing-order/standing-order-list/standing-order-list.component';
import { ListAddonComponent } from './components/configurations/addon/list-addon/list-addon.component';
import { AddAddonComponent } from './components/configurations/addon/add-addon/add-addon.component';
import { AppointmentlistComponent } from './components/configurations/appointment/appointment-list/appointmentlist.component';
import { AppointmenttypeComponent } from './components/configurations/appointment/add-appointment/appointmenttype.component';
import { TripMonitoringComponent } from './components/distributions/trips/trip-monitoring/trip-monitoring.component';
import { ServiceAreasAddComponent } from './components/configurations/service-areas/service-areas-add/service-areas-add.component';
import { ServiceAreasListingComponent } from './components/configurations/service-areas/service-areas-listing/service-areas-listing.component';
import { FundingSourceListComponent } from './components/configurations/funding-source/funding-source-list/funding-source-list.component';
import { AddFundingSourceComponent } from './components/configurations/funding-source/add-funding-source/add-funding-source.component';
import { ReportComponent } from './components/distributions/kpis/report/report.component';
import { ListCancelReasonComponent } from './components/configurations/cancelReason/list-cancel-reason/list-cancel-reason.component';
import { AddCancelReasonComponent } from './components/configurations/cancelReason/add-cancel-reason/add-cancel-reason.component';
import { ListPlacetypesComponent } from './components/configurations/placetypes/list-placetypes/list-placetypes.component';
import { AddPlacetypesComponent } from './components/configurations/placetypes/add-placetypes/add-placetypes.component';
import { FareListComponent } from './components/credentials/fare/fare-list/fare-list.component';
import { PartnerpayListComponent } from './components/partner-pay/partnerpay-list/partnerpay-list.component';
import { StandingOrderTripWrapperComponent } from './components/distributions/trip-intake/standing-order/standing-order-trip-wrapper/standing-order-trip-wrapper.component';
import { FileParsingComponent } from './components/distributions/trip-intake/file-parsing/file-parsing/file-parsing.component';
import { MemberParsingComponent } from './components/distributions/members/member-parsing/member-parsing.component';
import { PermissionGuard } from './services/app/permission-guard/permission.guard';
import { orderedSyncGuards } from './services/app/order-sequential-guard/orderSequential.guard';
import { SupportTicketsComponent } from './components/support/support-tickets/support-tickets.component';
import { SupportChatComponent } from './components/support/support-chat/support-chat.component';
import { TicketDetailComponent } from './components/support/ticket-detail/ticket-detail.component';
import { AddSupportTicketComponent } from './components/support/add-support-ticket/add-support-ticket.component';
import { StatisticsGraphViewComponent } from './components/distributions/kpis/statistics-graph-view/statistics-graph-view.component';
import { MapViewComponent } from './components/map/map-view/map-view.component';
import { ListEventComponent } from './components/configurations/event/list-event/list-event.component';
import { ListGpsComponent } from './components/configurations/gps/list-gps/list-gps.component';
import { MapDashboardComponent } from './components/dashboard/map-dashboard/map-dashboard.component';
import { AddConfigurationComponent } from './components/credentials/configuration/add-configuration/add-configuration.component';
import { CustomersListComponent } from './components/quickbook/customers/customers-list/customers-list.component';
import { AddCustomerComponent } from './components/quickbook/customers/add-customer/add-customer.component';
import { InvoicesListComponent } from './components/quickbook/invoices/invoices-list/invoices-list.component';
import { AddInvoiceComponent } from './components/quickbook/invoices/add-invoice/add-invoice.component';
import { ProductListComponent } from './components/quickbook/product-services/product-list/product-list.component';
import { AddProductServiceComponent } from './components/quickbook/product-services/add-product-service/add-product-service.component';
import { VendorsListComponent } from './components/quickbook/vendors/vendors-list/vendors-list.component';
import { AddVendorComponent } from './components/quickbook/vendors/add-vendor/add-vendor.component';
import { BillsListComponent } from './components/quickbook/bills/bills-list/bills-list.component';
import { AddBillComponent } from './components/quickbook/bills/add-bill/add-bill.component';
import { PayBillComponent } from './components/quickbook/bills/pay-bill/pay-bill.component';
import { ReceivePaymentComponent } from './components/quickbook/invoices/receive-payment/receive-payment.component';
import { BillPaymentsListComponent } from './components/quickbook/bill-payments/bill-payments-list/bill-payments-list.component';
import { InvoicePaymentsListComponent } from './components/quickbook/invoice-payments/invoice-payments-list/invoice-payments-list.component';
import { GlobalConfigurationComponent } from './components/credentials/configuration/global-configuration/global-configuration.component';
import { SectionsPermissionsGridComponent } from './components/role/sections-permissions-grid/sections-permissions-grid.component';
import { AdjustmentFormComponent } from './components/billing-vendor/adjustment-form/adjustment-form.component';
import { BillingListComponent } from './components/billing-vendor/billing-list/billing-list.component';
import { FsBillingListComponent } from './components/billing-fundingsource/fs-billing-list/fs-billing-list.component';
import { FsAdjustmentFormComponent } from './components/billing-fundingsource/fs-adjustment-form/fs-adjustment-form.component';
import { UploadAttachmentComponent } from './components/credentials/attachment/upload-attachment/upload-attachment.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password/forgot-password.component';
import { StagingTripComponent } from './components/distributions/trips/staging-trip/staging-trip.component';
import { PaymentsListComponent } from './components/payments/payments-list/payments-list.component';
import { TransactionsListComponent } from './components/payments/transactions-list/transactions-list.component';
import { ManualsListComponent } from './components/payments/manuals-list/manuals-list.component';
import { AddPrimaryDiagnosisComponent } from './components/billing/primary-diagnosis/add-primary-diagnosis/add-primary-diagnosis.component';
import { PrimaryDiagnosisListComponent } from './components/billing/primary-diagnosis/primary-diagnosis-list/primary-diagnosis-list.component';
import { ModifierCodesListComponent } from './components/billing/modifier-codes/modifier-codes-list/modifier-codes-list.component';
import { AddModifierCodeComponent } from './components/billing/modifier-codes/add-modifier-code/add-modifier-code.component';
import { TutorialListComponent } from './components/tutorials/tutorial-list/tutorial-list.component';
import { AddTutorialComponent } from './components/tutorials/add-tutorial/add-tutorial.component';
import { DocumentsStatisticsComponent } from './components/documents-statistics/documents-statistics.component';

const routes: Routes = [
  { path: 'login', component: SigninComponent, canActivate: [PublicGuard] },

  { path: '', redirectTo: '/signups', pathMatch: 'full' },

  {
    path: 'dashboard',
    component: MapDashboardComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_TRIP, UserPermission.GET_DRIVRER_ACTIVITY]
    }
  },

  // profile
  {
    path: 'profile', component: ProfileComponent, canActivate: [AuthGuard],
  },

  // Signups
  {
    path: 'signups',
    component: SignupListComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.GET_SIGNUP]
    }
  },

  {
    path: 'signups/add',
    component: AddSignupComponent,
    canActivate: [AuthGuard],

  },

  // Credentials
  {
    path: 'credentials',
    component: CredentialListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_ONBOARDING]
    }
  },

  {

    path: 'credentials/add',
    component: AddCredentialCompanyComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_COMPANY, UserPermission.MANAGE_COMPANY]
    }

  },

  {

    path: 'credentials/:companyId/config',
    component: AddConfigurationComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_COMPANY_CONFIGURATION, UserPermission.MANAGE_COMPANY_CONFIGURATION]
    }
  },


  {
    path: 'credentials/:id/edit',
    component: AddCredentialCompanyComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_COMPANY, UserPermission.MANAGE_COMPANY]
    }

  },

  {
    path: 'credentials/:companyId/driver/add',
    component: AddDriverComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_DRIVER]
    }


  },
  {
    path: 'credentials/:companyId/attachment/add',
    component: UploadAttachmentComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_DRIVER]
    }
  },
  {
    path: 'credentials/:companyId',
    component: WrapperComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_COMPANY]
    }
  },

  {
    path: 'credentials/company/:companyId/fare/add',
    component: AddFareComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.MANAGE_FARES]
    }

  },

  {
    path: 'credentials/company/:companyId/fare/:fareId/edit',
    component: AddFareComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.MANAGE_FARES]
    }

  },

  {
    path: 'credentials/company/:companyId/fare/:fareId/edit',
    component: FareListComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.MANAGE_FARES]
    }

  },



  // {
  //   path: 'configurations/funding-source/:fundingSourceId/fare',
  //   component: FareListComponent,
  //   canActivate: [AuthGuard],
  //   data: {
  //   }
  // },

  {
    path: 'credentials/:companyId/driver/:driverId/edit',
    component: AddDriverComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_DRIVER]
    }

  },

  {
    path: 'credentials/:companyId/vehicle/add',
    component: AddVehicleComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_VEHICLE]
    }


  },

  // Edit Vehicle
  {
    path: 'credentials/:companyId/vehicle/:vehicleId/edit',
    component: AddVehicleComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_VEHICLE]
    }

  },

  // Companies
  {
    path: 'companies',
    component: CompanyListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],

  },

  // Add Company
  {
    path: 'companies/add',
    component: AddCompanyComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_COMPANY]
    }


  },
  {
    path: 'companies/:id/edit',
    component: AddCompanyComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_COMPANY]
    }

  },

  // Configurations SpaceTypes
  {
    path: 'configurations/spacetypes',
    component: SpaceTypesListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_SPACE_TYPE]
    }


  },

  {
    path: 'configurations/spacetypes/add',
    component: AddSpaceTypesComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_SPACE_TYPE]
    }

  },

  {
    path: 'configurations/spacetypes/:id/edit', component: AddSpaceTypesComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_SPACE_TYPE]
    }
  },

  // { path: 'configurations', redirectTo: 'configurations/los', pathMatch: 'full'  },

  // Configurations LOS
  {
    path: 'configurations/los',
    component: LevelofserviceListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_LOS]
    }
  },

  {
    path: 'configurations/los/add',
    component: AddLevelofserviceComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_LOS]

    }
  },

  {
    path: 'configurations/los/:id/edit', component: AddLevelofserviceComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.MANAGE_LOS]
    }
  },

  {
    path: 'configurations/documents',
    component: DocumentsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],

  },

  {
    path: 'configurations/documents/add',
    component: AddDocumentComponent,
    canActivate: [AuthGuard],

  },

  {
    path: 'configurations/documents/:id/edit',
    component: AddDocumentComponent,
    canActivate: [AuthGuard],

  },

  //Appoinment Type:
  {
    path: 'configurations/appointmenttype',
    component: AppointmentlistComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_APPOINTMENT_TYPE]
    }

  },

  {
    path: 'configurations/appointmenttype/add',
    component: AppointmenttypeComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_APPOINTMENT_TYPE]
    }
  },
  {
    path: 'configurations/appointmenttype/:appointmentTypeId/edit',
    component: AppointmenttypeComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_APPOINTMENT_TYPE]
    }
  },

  //Addons:

  {
    path: 'configurations/addons',
    component: ListAddonComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_ADDON]
    }
  },

  {
    path: 'configurations/addons/add',
    component: AddAddonComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ADDON]
    }
  },
  {
    path: 'configurations/addons/:addonId/edit',
    component: AddAddonComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ADDON]
    }
  },
  {
    path: 'configurations/service-areas', component: ServiceAreasListingComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.GET_SERVICE_AREAS]
    }
  },

  {
    path: 'configurations/service-areas/add', component: ServiceAreasAddComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.MANAGE_SERVICE_AREAS]
    }
  },
  {
    path: 'configurations/service-areas/:id/edit', component: ServiceAreasAddComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.MANAGE_SERVICE_AREAS]
    }
  },

  // Funding Sources
  {
    path: 'funding-sources', component: FundingSourceListComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.GET_FUNDING_SOURCE]
    }
  },
  {
    path: 'funding-sources/add', component: AddFundingSourceComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.MANAGE_FUNDING_SOURCE]
    }
  },
  {
    path: 'funding-sources/:id/edit', component: AddFundingSourceComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.MANAGE_FUNDING_SOURCE]
    }
  },
  {
    path: 'funding-sources/:fundingSourceId/fare',
    component: FareListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_FARES]
    }
  },
  {
    path: 'funding-sources/:fundingSourceId/fare/add',
    component: AddFareComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_FARES]
    }
  },
  {
    path: 'funding-sources/:fundingSourceId/fare/:fareId/edit',
    component: AddFareComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_FARES]
    }

  },







  // Cancel Reasons
  {
    path: 'configurations/change-reasons', component: ListCancelReasonComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.GET_CHANGE_REASON]
    }
  },
  {
    path: 'configurations/change-reasons/add', component: AddCancelReasonComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.MANAGE_CHANGE_REASON]
    }
  },
  {
    path: 'configurations/change-reasons/:change-reasons/edit', component: AddCancelReasonComponent, canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])], data: {
      permissions: [UserPermission.MANAGE_CHANGE_REASON]
    }
  },
  //Place Types:
  {
    path: 'configurations/place-types',
    component: ListPlacetypesComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_PLACE_TYPES]
    }
  },

  {
    path: 'configurations/place-types/add',
    component: AddPlacetypesComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_PLACE_TYPES]
    }
  },
  {
    path: 'configurations/place-types/:place-types/edit',
    component: AddPlacetypesComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_PLACE_TYPES]
    }
  },

  // Configuratoin
  {
    path: 'configurations/global',
    component: GlobalConfigurationComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_CONFIGURATION]
    }
  },

  // Credentials
  {
    path: 'credentialing/:id',
    component: WrapperComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
  },

  {
    path: 'credentialing/company',
    component: CompanyComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
  },

  {
    path: 'credentialing/driver',
    component: DriverComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.GET_DRIVER, UserPermission.MANAGE_DRIVER]
    }
  },
  {
    path: 'credentialing/threshold',
    component: ThresholdListComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.GET_THRESHOLD, UserPermission.MANAGE_THRESHOLD]
    }
  },



  // Threshold
  {
    path: 'credentials/:companyId/threshold',
    component: ThresholdListComponent,
  },

  // Users

  {
    path: 'users',
    component: UsersListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_USERS]
    }
  },

  {
    path: 'credentials/:companyId/threshold/add',
    component: ThresholdComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_THRESHOLD]
    }
  },

  {
    path: 'credentials/:companyId/threshold/:thrsholdId/edit',
    component: ThresholdComponent,
    data: {
      permissions: [UserPermission.MANAGE_THRESHOLD]
    }
  },

  {
    path: 'users/add',
    component: AddUserComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_USERS]
    }
  },

  {
    path: 'users/:userId/edit',
    component: AddUserComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_USERS]
    }
  },

  //members

  {
    path: 'members',
    component: MemberListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_MEMBER]
    }
  },
  {
    path: 'members/parse',
    component: MemberParsingComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_MEMBER]
    }
  },
  {
    path: 'members/add',
    component: AddMemberComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_MEMBER]
    }
  },
  {
    path: 'members/:memberId/edit',
    component: AddMemberComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_MEMBER]
    }
  },

  {
    path: 'parsetrips',
    component: FileParsingComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_MEMBER_TRIP, UserPermission.MANAGE_FUNDING_SOURCE_TRIP]
    }
  },

  //role:
  {
    path: 'roles',
    component: ListRoleComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_ROLE]
    }
  },
  {
    path: 'roles/add',
    component: AddRoleComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ROLE]
    }
  },
  {
    path: 'roles/:roleId/edit',
    component: AddRoleComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ROLE]
    }
  },
  {
    path: 'roles/permissions',
    component: SectionsPermissionsGridComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_ROLE, UserPermission.MANAGE_ROLE]
    }
  },

  // support
  {
    path: 'support',
    redirectTo: 'support/tickets',
    pathMatch: 'full'
  },
  {
    path: 'support/tickets',
    component: SupportTicketsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/chats',
    component: SupportChatComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/tickets/add',
    component: AddSupportTicketComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/tickets/:id',
    component: TicketDetailComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'statistics',
    component: ReportComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.GET_TRIP]
    }
  },
  {
    path: 'statistics/overview',
    component: StatisticsGraphViewComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.GET_TRIP]
    }
  },

  {
    path: 'statistics/reports',
    component: PartnerpayListComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.GET_TRIP]
    }
  },

  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.GET_NOTIFICATION]
    }
  },

  // Trips

  {
    path: 'trips',
    component: TripListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_TRIP]
    }
  },
  {
    path: 'trips/new',
    component: CreateTripComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },
  {
    path: 'trips/:tripId/edit',
    component: CreateTripComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },
  {
    path: 'trips/parsetrips',
    component: FileParsingComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },

  // staging trips 
  {
    path: 'trips/staging',
    component: StagingTripComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },
  // Event
  {
    path: 'trips/event',
    component: ListEventComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_EVENT]
    }
  },
  // gps
  {
    path: 'trips/gps',
    component: ListGpsComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_GPS]
    }
  },
  {
    path: 'trips/standing-order',
    component: StandingOrderListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_STANDING_ORDER]
    }
  },
  {
    path: 'trips/standing-order/new',
    component: StandingOrderTripWrapperComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_STANDING_ORDER]
    }
  },
  {
    path: 'trips/:standingOrderId/standing-order/edit',
    component: StandingOrderTripWrapperComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_STANDING_ORDER]
    }
  },
  {
    path: 'trips/monitoring',
    component: TripMonitoringComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_TRIP]
    }
  },
  {
    path: 'billing/vendor',
    component: BillingListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_BILLINGS]
    }
  },
  {
    path: 'billing/vendor/:id/adjustTrip',
    component: AdjustmentFormComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_BILLINGS]
    }
  },
  {
    path: 'trips/vendor/:id/adjustTrip',
    component: AdjustmentFormComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },
  {
    path: 'billing/fundingsource',
    component: FsBillingListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_BILLINGS]
    }
  },
  {
    path: 'billing/fundingsource/:id/adjustTrip',
    component: FsAdjustmentFormComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_BILLINGS]
    }
  },
  {
    path: 'trips/fundingsource/:id/adjustTrip',
    component: FsAdjustmentFormComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },

  // path: 'credentials/:companyId/vehicle/:vehicleId/edit',

  // Map View
  {
    path: 'mapview',
    component: MapViewComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ROLE]
    }
  },

  // ----Quickbook routes ---


  // notifications

  {
    path: 'quickbook/notifications',
    component: QuickbookNotificationsComponent,
    canActivate: [AuthGuard],
  },

  // customers

  {
    path: 'quickbook/customers',
    component: CustomersListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/customers/add',
    component: AddCustomerComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/customers/:id/edit',
    component: AddCustomerComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  // Invoices
  {
    path: 'quickbook/invoices',
    component: InvoicesListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/invoices/add',
    component: AddInvoiceComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/invoices/:id/edit',
    component: AddInvoiceComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/invoices/:id/receive-payment',
    component: ReceivePaymentComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },


  // product list
  {
    path: 'quickbook/services',
    component: ProductListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/services/add',
    component: AddProductServiceComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/services/:id/edit',
    component: AddProductServiceComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/vendors',
    component: VendorsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },
  {
    path: 'quickbook/vendors/add',
    component: AddVendorComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },
  {
    path: 'quickbook/vendors/:id/edit',
    component: AddVendorComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'quickbook/bills',
    component: BillsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },
  {
    path: 'quickbook/bills/add',
    component: AddBillComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },
  {
    path: 'quickbook/bills/:id/edit',
    component: AddBillComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },
  {
    path: 'quickbook/bills/:id/pay',
    component: PayBillComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },
  {
    path: 'quickbook/bill-payments',
    component: BillPaymentsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },
  {
    path: 'quickbook/payments',
    component: InvoicePaymentsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    }
  },

  {
    path: 'payments',
    component: PaymentsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_PAYMENT]
    }
  },
  {
    path: 'payments/manuals',
    component: ManualsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_PAYMENT]
    }
  },
  {
    path: 'payments/transactions',
    component: TransactionsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_PAYMENT]
    }
  },
  {
    path: 'billing/primary-diagnosis',
    component: PrimaryDiagnosisListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_BILLINGS]
    }
  },
  {
    path: 'billing/primary-diagnosis/add',
    component: AddPrimaryDiagnosisComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_BILLINGS]
    }
  },
  {
    path: 'billing/primary-diagnosis/:id/edit',
    component: AddPrimaryDiagnosisComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_BILLINGS]
    }
  },
  {
    path: 'billing/modifier-codes',
    component: ModifierCodesListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_BILLINGS]
    }
  },
  {
    path: 'billing/modifier-codes/add',
    component: AddModifierCodeComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_BILLINGS]
    }
  },
  {
    path: 'billing/modifier-codes/:id/edit',
    component: AddModifierCodeComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_BILLINGS]
    }
  },

  // academy
  {
    path: 'academy',
   component: TutorialListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_ACADEMY]
    }
  },
  {
    path: 'academy/add',
    component: AddTutorialComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ACADEMY]
    }
  },

  {
    path: 'academy/:id/edit',
    component: AddTutorialComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_ACADEMY]
    }
  },
  {
    path: 'documents-statistics',
    component: DocumentsStatisticsComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_DOCUMENT_STATS]
    }
  }

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
